function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#FFF",
  d: "M19.2 38.4l.6 1.2a.7.7 0 0 0 1.2 0l.7-1.2c.8-1.5 1.2-3.2 1.2-4.9V12.1c0-1.5-.2-3-.6-4.3l-1.9-5.4-1.8 5.4c-.4 1.4-.6 2.8-.6 4.3v21.4c0 1.7.4 3.4 1.2 5z"
}), React.createElement("path", {
  fill: "#46C3D7",
  d: "M19.2 36.5v.1c.3.4.7.6 1.2.7h.1c.5 0 .9-.3 1.1-.6v-.2l.3-.6c0-.1-.1-.1-.2 0l-.3.4c-.3.3-.6.4-.9.4h-.1c-.3 0-.6-.1-.8-.3l-.2-.1-.3-.4v.6"
}), React.createElement("path", {
  fill: "#145569",
  d: "M26.5 26.6H29l-.2-2v-1c0-.4-.4-.7-.8-.7h-.7c-.4 0-.8.3-.8.7l-.1 2.6v.4h.2zM26.4 27.1H28.7l.2-.2v-.3H26.2v.3c0 .1 0 .2.2.2M31.2 24.1H33.5s.2 0 .2-.2v-.3H31v.3c0 .1 0 .2.2.2M31.3 23.6h2.4l-.2-2.2v-.7c0-.5-.4-.8-.8-.8H32c-.4 0-.8.3-.8.8L31 23v.6h.3zM14.3 26.6a8.2 8.2 0 0 1-2 0H12l.1-2v-1c0-.3.4-.7.8-.7h.7c.5 0 .8.4.8.8l.2 2.5v.4h-.3z"
}), React.createElement("path", {
  fill: "#145569",
  d: "M14.4 27h-.1a8.2 8.2 0 0 1-2 0h-.2a.2.2 0 0 1-.1-.1v-.4h.3a8.2 8.2 0 0 0 2 0h.3v.4s0 .2-.2.2M9.7 24h-.2a7 7 0 0 1-2 0H7.2v-.4h.3a7 7 0 0 0 2 0h.4v.3l-.2.2"
}), React.createElement("path", {
  fill: "#145569",
  d: "M9.5 23.6a7 7 0 0 1-2 0h-.3l.1-2.2v-.8c0-.4.4-.7.8-.7h.7c.4 0 .8.3.8.7l.2 2.3v.6h-.3z"
}), React.createElement("path", {
  fill: "#B93296",
  d: "M40.8 13.9l-15.6 4.9-2.3.7V28l2.3-1.6 14.9-9.9z"
}), React.createElement("path", {
  fill: "#DFABD1",
  d: "M40.1 16.5L22.9 28v-1l17.6-11.7z"
}), React.createElement("path", {
  fill: "#B93296",
  d: "M0 13.9l15.6 4.9 2.4.7V28l-2.4-1.6L.8 16.5z"
}), React.createElement("path", {
  fill: "#DFABD1",
  d: "M.8 16.5L18 28v-1.1L.4 15.3z"
}), React.createElement("path", {
  fill: "#B93296",
  d: "M13.2.3l4.8 2 2.1.8-.1 4.5-2-1.7-4.7-4.1z"
}), React.createElement("path", {
  fill: "#DFABD1",
  d: "M13.3 1.8L20 7.6v-.8L13.2.9z"
}), React.createElement("path", {
  fill: "#B93296",
  d: "M27.7.3l-4.8 2-2.2.8.2 4.5 2-1.7 4.7-4.1z"
}), React.createElement("path", {
  fill: "#DFABD1",
  d: "M27.6 1.8l-6.7 5.8v-.8L27.7.9z"
}), React.createElement("path", {
  fill: "#DFABD1",
  d: "M20.4 9.5A.4.4 0 0 0 21 9L20.7.2c0-.1-.1-.2-.3-.2l-.2.2L20 9c0 .3.2.5.4.5z"
}));

var SvgPlane4 = function SvgPlane4(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 41 40",
    width: 41,
    height: 40,
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlane4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plane4.1f4b0de6.svg";
export { ForwardRef as ReactComponent };